export default function LeftSidePanel() {
  return <div style={{ gridArea: "LeftSidePanel" }}>LeftSidePanel</div>;
}
